import { getAPIByEnviorment } from '@configs/api';
import axios from 'axios';
// 아래는 api 연동 axios
export const axiosInstance = axios.create({
  // baseURL: `${getAPIByEnviorment()}/`,
  baseURL: 'http://192.168.20.116:8081/',
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true,
});

// 아래는 scraper 연동 axios
export const axiosScraper = axios.create({
  // baseURL: 'https://aix-ts-scraper.herokuapp.com/',
  // baseURL: 'http://175.45.193.156:8082/',
  baseURL: 'https://175.45.193.156/',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const axiosDummyInstance = axios.create({
  baseURL: `${getAPIByEnviorment()}`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});
//export default AxiosInstance;

export const axiosDummyReqTypeInstance = <IParams>(params: IParams) => {
  console.log('requestParams: ', params);
  return axios.create({
    baseURL: `${getAPIByEnviorment()}`,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
};
